import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/CinematicLanding";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import DashboardHome from "./pages/DashboardHome";
import SubmitJob from "./pages/SubmitJob";
import JobsList from "./pages/JobsList";
import JobDetail from "./pages/JobDetail";
import Results from "./pages/Results";
import Pricing from "./pages/Pricing";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import GenerateStudio from "./pages/GenerateStudio";
import MyLibrary from "./pages/MyLibrary";
import CommunityFeed from "./pages/CommunityFeed";
import SketchCanvas from "./pages/SketchCanvas";
import ImageToVideo from "./pages/ImageToVideo";
import ModelsPage from "./pages/ModelsPage";
import About from "./pages/About";
import FAQPage from "./pages/FAQ";
import NotFound from "./pages/NotFound";
import BlogIndex from "./pages/blog/BlogIndex";
import BlogPost from "./pages/blog/BlogPost";
import CommandPalette from "./components/CommandPalette";
import SmoothScroll from "./cinematic/SmoothScroll";
import MagneticCursor from "./cinematic/MagneticCursor";
import PageTransition from "./cinematic/PageTransition";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/generate" element={<ProtectedRoute><GenerateStudio /></ProtectedRoute>} />
      <Route path="/canvas" element={<ProtectedRoute><SketchCanvas /></ProtectedRoute>} />
      <Route path="/image-to-video" element={<ProtectedRoute><ImageToVideo /></ProtectedRoute>} />
      <Route path="/models" element={<ModelsPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/library" element={<ProtectedRoute><MyLibrary /></ProtectedRoute>} />
      <Route path="/community" element={<CommunityFeed />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="submit" element={<SubmitJob />} />
        <Route path="jobs" element={<JobsList />} />
        <Route path="jobs/:jobId" element={<JobDetail />} />
        <Route path="results" element={<Results />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SmoothScroll>
          <PageTransition>
            <AppRouter />
          </PageTransition>
          <CommandPalette />
          <MagneticCursor />
        </SmoothScroll>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: '#0A0A0A', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
